import type { CodeBidiWarningPluginState } from './types';

export default (
	pluginState: CodeBidiWarningPluginState,
	action: unknown,
): CodeBidiWarningPluginState => {
	return pluginState;
};
